'use client';
import React, { useState, useReducer, useEffect } from 'react'
import RealEstatePageLayout from '../../components/partials/RealEstatePageLayout'
import Link from 'next/link'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Dropdown from 'react-bootstrap/Dropdown'
import Badge from 'react-bootstrap/Badge'
import Collapse from 'react-bootstrap/Collapse'
import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Modal from 'react-bootstrap/Modal'
import CloseButton from 'react-bootstrap/CloseButton'
import Pager from 'react-bootstrap/Pagination'
import ImageLoader from '../../components/ImageLoader'
import GalleryItem from '../../components/GalleryItem'
import StarRating from '../../components/StarRating'
import SocialButton from '../../components/SocialButton'
import Review from '../../components/Review'
import PropertyCard from '../../components/PropertyCard'
import LightGallery from 'lightgallery/react'
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgFullScreen from 'lightgallery/plugins/fullscreen'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'lightgallery/css/lightgallery.css'
import 'lightgallery/css/lg-thumbnail.css'
import 'lightgallery/css/lg-zoom.css'
import 'lightgallery/css/lg-fullscreen.css'
import 'lightgallery/css/lg-video.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { useRouter } from "next/router";
import moment from "moment";
import "moment/locale/fr";
import Placeholder from "react-bootstrap/Placeholder";
import Accordion from "react-bootstrap/Accordion";
import PriceProperty from "../../components/PriceProperty";
import DetailProperty from '../../components/DetailProperty'
// import moment from "moment/fr";
import axios from "axios";
import dynamic from "next/dynamic";
import 'react-international-phone/style.css';
import Swal from 'sweetalert2'
import { useTranslation } from "react-i18next";
import { event } from 'nextjs-google-analytics';
import { absoluteUrl, listingPath, listingIdFromSlug, localizedPath } from '../../libs/utils/seo';


// lightgallery builds its thumbnail strip on page load: use small optimized
// versions, not the full-size originals (~450 KB each)
const galleryThumb = (path) => `/_next/image?url=${encodeURIComponent(`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${path}`)}&w=256&q=75`

// The phone field (country list + ~140 KB of phone-number data) is only needed
// for the visit form at the bottom: load it on demand. Until then, a plain input
// of the same height holds its place (no layout shift).
const PhoneInput = dynamic(
    () => import('react-international-phone').then(({ PhoneInput, defaultCountries }) => {
        const PhoneInputWithCountries = (props) => <PhoneInput countries={defaultCountries} {...props} />
        return PhoneInputWithCountries
    }),
    {
        ssr: false,
        loading: () => <input className='form-control' placeholder='+212 6 20 48 62 77' style={{ height: 'calc(1.5em + 0.75rem + 8px)' }} disabled aria-hidden='true' />,
    }
)

const Gallery = ({ images, title = '' }) => {
    const { t } = useTranslation('common');

    return (
        <>
            <Col xs={8}>
                <GalleryItem
                    href={`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${images[0]?.path}`}
                    thumb={[`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${images[0]?.path}`, 920, 650]}
                    data-external-thumb-image={galleryThumb(images[0]?.path)}
                    imgAlt={`${title} - 1`}
                    className='rounded rounded-md-3'
                />
            </Col>
            <Col xs={4}>
                {images.slice(1, 3).map((image, index) => (
                    <GalleryItem
                        key={image.id || index}
                        href={`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${image.path}`}
                        thumb={[`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${image.path}`, 450, 316]}
                        data-external-thumb-image={galleryThumb(image.path)}
                        imgAlt={`${title} - ${index + 2}`}
                        className={`rounded rounded-md-3 ${index === 0 ? 'mb-2 mb-md-3' : ''}`}
                    />
                ))}
            </Col>
            <Col xs={12}>
                <Row className='g-2 g-md-3'>
                    {images.slice(3).map((image, index) => (
                        <Col key={image.id || index}>
                            <GalleryItem
                                href={`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${image.path}`}
                                thumb={[`${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${image.path}`, 262, 160]}
                                data-external-thumb-image={galleryThumb(image.path)}
                                imgAlt={`${title} - ${index + 4}`}
                                caption={
                                    index === 4 ? (
                                        <>
                                            +5 <span className='d-none d-md-inline'>{t("photos")}</span>
                                        </>
                                    ) : null
                                }
                                className={`rounded-1 rounded-md-2 ${index === 4 ? 'more-item' : ''
                                    }`}
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </>
    );
}
const SinglePropertyPage = (props) => {
    const { t } = useTranslation('common');

    const router = useRouter();
    const { id } = router.query;
    // The listing comes from getServerSideProps, so it is part of the
    // server-rendered HTML (SEO) and doesn't need a second client fetch.
    const property = props;
    const loading = false;

    const [phoneNumber, setPhoneNumber] = useState('');
    const [touched, setTouched] = useState(false);
    const [isValid, setIsValid] = useState(false);

    moment.locale('fr');

    const baseUrl = 'https://www.facilykey.com';

    const shareUrl = `${baseUrl}${router.asPath}`;

    // Validation data is loaded only once a number is typed
    useEffect(() => {
        if (!phoneNumber) {
            setIsValid(false);
            return;
        }
        let cancelled = false;
        import('google-libphonenumber').then((mod) => {
            if (cancelled) return;
            // CommonJS package: its exports may sit under `default` when imported dynamically
            const { PhoneNumberUtil } = mod.PhoneNumberUtil ? mod : mod.default;
            try {
                const phoneUtil = PhoneNumberUtil.getInstance();
                setIsValid(phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phoneNumber)));
            } catch (error) {
                setIsValid(false);
            }
        });
        return () => { cancelled = true; };
    }, [phoneNumber]);


    // Review with actionable Like / Dislike buttons
    const ReviewActionable = ({ authorImg, authorName, rating, date, text, likesNum, dislikesNum, ...props }) => {
        const initialState = {
            likes: likesNum,
            dislikes: dislikesNum,
            active: null
        }

        const reducer = (state, action) => {
            const { likes, dislikes, active } = state

            switch (action.type) {
                case 'likeHandle':
                    return {
                        ...state,
                        likes: state.likes + 1,
                        dislikes: active === 'dislike' ? dislikes - 1 : dislikes,
                        active: 'like'
                    }
                case 'dislikeHandle':
                    return {
                        ...state,
                        dislikes: state.dislikes + 1,
                        likes: active === 'like' ? likes - 1 : likes,
                        active: 'dislike'
                    }
                default:
                    return state
            }
        }

        const [state, dispatch] = useReducer(reducer, initialState)
        const { likes, dislikes, active } = state

        return (
            <Review
                author={{
                    thumbSrc: authorImg,
                    thumbSize: 48,
                    thumbShape: 'rounded-circle',
                    name: authorName
                }}
                rating={rating}
                date={date}
                likeActive={active === 'like' ? true : false}
                dislikeActive={active === 'dislike' ? true : false}
                likeCount={likes}
                dislikeCount={dislikes}
                likeClick={() => active !== 'like' ? dispatch({ type: 'likeHandle' }) : null}
                dislikeClick={() => active !== 'dislike' ? dispatch({ type: 'dislikeHandle' }) : null}
                {...props}
            >
                {text}
            </Review>
        )
    }

    // Add review modal
    const [modalShow, setModalShow] = useState(false)
    const handleModalClose = () => setModalShow(false)
    const handleModalShow = () => setModalShow(true)

    // Contact form validation
    const [contactValidated, setContactValidated] = useState(false)

    const handleContactSubmit = async (e) => {


        const match = id.match(/FKB(\d+)/);
        const id_property = match[1];

        const form = e.currentTarget;
        e.preventDefault();


        if (form.checkValidity() === false || !isValid) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        setContactValidated(true);


        const values = {
            id_property_demande_visite: id_property,
            nom_demande_visite: form.elements.nom.value,
            prenom_demande_visite: form.elements.prenom.value,
            email_demande_visite: form.elements.email.value,
            telephone_demande_visite: phoneNumber,
            message_demande_visite: form.elements.message.value,
        };


        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            formData.append(key, values[key]);
        });
        if (window.fbq) {
            window.fbq('track', 'Lead', {
                content_name: 'Demande de visite',
                content_category: 'Immobilier',
                property_reference: `FKB-${id_property}`,
                property_id: id_property,
                currency: 'MAD',
            });
        }
        event('generate_lead', {
            event_category: 'Contact Form',
            event_label: id_property,
            value: 1
        });
        axios.post(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/leads/visit`, formData).then(function (response) {

            Swal.fire({
                text: response?.message,
                icon: "success",
                buttonsStyling: !1,
                confirmButtonText: "Ok, Merci!",
                customClass: {
                    confirmButton: "btn btn-primary"
                }
            }).then(() => {
                window.location.reload();
            });
        })
            .catch(function (error) {
                console.error(error);
            });



    };

    // Add review form validation
    const [reviewValidated, setReviewValidated] = useState(false)
    const handleReviewSubmit = (e) => {
        const form = e.currentTarget
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        }
        setReviewValidated(true);
    }
    // Contact form date picker state
    const [startDate, setStartDate] = useState(null)

    // Overview collapse state
    const [overviewOpen, setOverviewOpen] = useState(false)

    // if (loading) {
    //     return <div>Loading.</div>;
    // }
    const getWhatsAppUrl = () => {
        let isMobile = false;
        if (typeof window !== 'undefined' || typeof Document !== 'undefined') {
            navigator?.clipboard?.writeText(shareUrl).catch(err => console.log(err));
            isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        }
        const text = `${property?.title ?? ''} ${shareUrl}`;

        return isMobile
            ? `whatsapp://send?text=${encodeURIComponent(text)}`
            : `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`;
    };

    // Structured data for rich results (price, location, photos) + breadcrumb
    const listingUrl = absoluteUrl(listingPath(property.title, property.id_property), router.locale);
    const imageUrl = (path) => `${process.env.NEXT_PUBLIC_API_URL}/fichiers/properties/${path}`;
    const priceValue = Number(String(property.price ?? '').replace(/[^\d]/g, '')) || undefined;
    const listingJsonLd = [
        {
            '@context': 'https://schema.org',
            '@type': 'RealEstateListing',
            name: property.title,
            description: property.description_fiche_commerciale || property.title,
            url: listingUrl,
            datePosted: property.created_at ? property.created_at.slice(0, 10) : undefined,
            image: (property.images || []).slice(0, 10).map((image) => imageUrl(image.path)),
            offers: priceValue && {
                '@type': 'Offer',
                price: priceValue,
                priceCurrency: 'MAD',
                businessFunction: property.mandat === 'location'
                    ? 'http://purl.org/goodrelations/v1#LeaseOut'
                    : 'http://purl.org/goodrelations/v1#Sell',
                availability: 'https://schema.org/InStock',
            },
            contentLocation: {
                '@type': 'Place',
                address: {
                    '@type': 'PostalAddress',
                    addressLocality: property.ville,
                    postalCode: property.code_postal || undefined,
                    addressCountry: 'MA',
                },
            },
        },
        {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
                { '@type': 'ListItem', position: 1, name: t('Accueil'), item: absoluteUrl('/', router.locale) },
                { '@type': 'ListItem', position: 2, name: t('Annonces de biens'), item: absoluteUrl('/catalog', router.locale) },
                { '@type': 'ListItem', position: 3, name: property.title, item: listingUrl },
            ],
        },
    ];
    const metaDescription = [
        property.title,
        property.price,
        property.quartier && property.quartier !== property.ville ? `${property.quartier}, ${property.ville}` : property.ville,
        property.bedrooms ? `${property.bedrooms} ${t('chambres')}` : null,
    ].filter(Boolean).join(' - ') + '. ' + t('Visite et estimation gratuites avec Facilykey.');

    return (
        <RealEstatePageLayout
            suppressHydrationWarning
            pageTitle={props.title}
            activeNav='Catalog'
            canonicalPath={listingPath(property.title, property.id_property)}
            description={metaDescription.slice(0, 160)}
            image={property.thumbnail ? imageUrl(property.thumbnail) : undefined}
            ogType='article'
            jsonLd={listingJsonLd}
        >

            {/* Page header */}
            <Container as='section' className='pt-5 mt-5 pb-1'>

                {/* Breadcrumb */}
                <Breadcrumb className='mb-3 pt-md-3'>
                    <Breadcrumb.Item linkAs={Link} href='/'>{t("Accueil")}</Breadcrumb.Item>
                    <Breadcrumb.Item linkAs={Link} href='/catalog'>{t("Annonces de biens")}</Breadcrumb.Item>
                    {loading ? (
                        <Breadcrumb.Item active><Placeholder xs={3} size='xs' style={{ width: 100 }} /></Breadcrumb.Item>
                    ) : (
                        <Breadcrumb.Item active>{property?.title}</Breadcrumb.Item>
                    )}

                </Breadcrumb>

                {loading ? <Placeholder xs={4} size='lg' className={'h2 mb-2'} /> : <h1 className='h2 mb-2'>{property?.title}</h1>}
                {loading ? <Placeholder xs={9} size='sm' className={'mb-2 pb-1 '} /> : <p className='mb-2 pb-1 fs-lg'>{property?.quartier ? property?.quartier + ", " : ""}{property?.ville ? property?.ville + " - " : ""}{property?.code_postal}</p>}



                <div className='d-flex justify-content-between align-items-center'>

                    {/* Amenities */}
                    {loading ? (<div className={'mb-4'}>
                        <Placeholder xs={9} size='sm' className={'mb-2 pb-1 '} />
                    </div>)
                        :
                        (
                            <ul className='d-flex mb-4 list-unstyled'>
                                <li className='me-3 pe-3 border-end'>
                                    <b className='me-1'>{property?.bedrooms ?? 0}</b>
                                    <i className='fi-bed mt-n1 lead align-middle text-muted'></i>
                                </li>
                                <li className='me-3 pe-3 border-end'>
                                    <b className='me-1'>{property?.bathrooms ?? 0}</b>
                                    <i className='fi-bath mt-n1 lead align-middle text-muted'></i>
                                </li>
                                <li className='me-3 pe-3 border-end'>
                                    <b className='me-1'>{property?.garages ?? 0}</b>
                                    <i className='fi-parking mt-n1 lead align-middle text-muted'></i>
                                </li>
                                <li>
                                    <b>{property?.surface} </b>
                                    m²
                                </li>
                            </ul>
                        )}


                    {/* Wishlist + Sharing */}
                    <div className='text-nowrap pb-3'>
                        {/*<OverlayTrigger*/}
                        {/*    placement='top'*/}
                        {/*    overlay={<Tooltip>Ajouter aux favoris</Tooltip>}*/}
                        {/*>*/}
                        {/*    <Button size='xs' variant='icon btn-light-primary shadow-sm rounded-circle'>*/}
                        {/*        <i className='fi-heart'></i>*/}
                        {/*    </Button>*/}
                        {/*</OverlayTrigger>*/}
                        <Dropdown className='d-inline-block'>
                            <OverlayTrigger
                                placement='top'
                                overlay={<Tooltip>{t("Partager")}</Tooltip>}
                            >
                                <Dropdown.Toggle variant='secondary btn-xs ms-2 text-black'>
                                    <i className='fi-share me-2'></i>
                                    {t('Partager')}
                                </Dropdown.Toggle>
                            </OverlayTrigger>
                            <Dropdown.Menu align='end' className='my-1'>
                                <Dropdown.Item as={Link} href={'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl)} target={'_blank'}>
                                    <i className='fi-facebook fs-base opacity-75 me-2'></i>
                                    Facebook
                                </Dropdown.Item>
                                <Dropdown.Item as={Link} target="_blank" href={'https://twitter.com/intent/tweet?url=' + encodeURIComponent(shareUrl) + '&title=' + encodeURIComponent(property?.title ?? '')}>
                                    <i className='fi-twitter fs-base opacity-75 me-2'></i>
                                    Twitter
                                </Dropdown.Item>
                                <Dropdown.Item
                                    as={Link}
                                    target="_blank"
                                    href={getWhatsAppUrl()}
                                >
                                    <i className='fi-whatsapp fs-base opacity-75 me-2'></i>
                                    WhatsApp
                                </Dropdown.Item>
                                <Dropdown.Item as='button' onClick={() => navigator?.clipboard?.writeText(shareUrl)}>
                                    <i className='fi-instagram fs-base opacity-75 me-2'></i>
                                    {t("Copier le lien pour Instagram")}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
            </Container>


            {/* Gallery */}
            <Container as='section' className='overflow-auto mb-4 pb-3'>
                <LightGallery
                    selector='.gallery-item'
                    licenseKey='D4194FDD-48924833-A54AECA3-D6F8E646'
                    plugins={[lgThumbnail, lgZoom, lgFullScreen]}
                    zoomFromOrigin={false}
                    exThumbImage='data-external-thumb-image'
                >
                    <Row className='g-2 g-md-3' style={{ minWidth: '30rem' }}>
                        {loading ? (<Placeholder xs={'4'} size={'xs'} />) : (<Gallery images={property?.images} title={property?.title} />)}
                    </Row>
                </LightGallery>
            </Container>


            {/* Post content */}
            <Container as='section' className='mb-5 pb-1'>
                <Row>
                    <Col md={7} className='mb-md-0 mb-4'>
                        {loading ? (
                            <>
                                <Placeholder xs={'4'} size={'xs'} /><br />
                                <div className={'h2 mb-4 pb-4 border-bottom'}>
                                    <Placeholder xs={'6'} size={'lg'} />
                                </div>
                            </>
                        ) : (
                            <>
                                <Badge bg='info' className='me-2 mb-3'>{property?.type}</Badge>

                                {/* Price */}
                                <h2 className='h2 mb-4 pb-4 border-bottom'>
                                    {property?.price}
                                    {/*<span className='d-inline-block ms-1 fs-base fw-normal text-muted'> soit {property.prix_vente/property.surface}/m²</span>*/}
                                </h2>
                            </>
                        )}

                        {/* Overview */}
                        <div className='mb-4 pb-md-3'>
                            <h3 className='h4'>{t("Descriptif")}</h3>
                            {loading ? (
                                <>
                                    <Placeholder size={'sm'} xs={9} /><br />
                                    <Placeholder size={'sm'} xs={7} /><br />
                                    <Placeholder size={'sm'} xs={7} /><br />
                                    <Placeholder size={'sm'} xs={6} /><br />
                                </>
                            ) : (
                                <>
                                    <span className='mb-1'>
                                        {property?.description_fiche_commerciale?.split("\n").map((line, index) => (<React.Fragment key={index}> {line} <br /> </React.Fragment>))}
                                    </span>
                                    {/*<Collapse in={overviewOpen}>*/}
                                    {/*    <span>{property?.description_fiche_commerciale?.substring(400, property?.description_fiche_commerciale.length)}</span>*/}
                                    {/*</Collapse>*/}
                                    {/*<a*/}
                                    {/*    href='#'*/}
                                    {/*    onClick={(e) => {*/}
                                    {/*        e.preventDefault()*/}
                                    {/*        setOverviewOpen(!overviewOpen)*/}
                                    {/*    }}*/}
                                    {/*    aria-controls='moreOverview'*/}
                                    {/*    aria-expanded={overviewOpen}*/}
                                    {/*    className={`collapse-label${overviewOpen ? '' : ' collapsed'}`}*/}
                                    {/*>*/}
                                    {/*    {overviewOpen ? 'Afficher moins' : 'Afficher plus'}*/}
                                    {/*</a>*/}
                                </>
                            )}
                        </div>

                        {/* Property details list */}
                        {/* <div className='mb-4 pb-md-3'>
                            <h3 className='h4'>Caractéristiques</h3>
                            <ul className='list-unstyled mb-0'>
                                {loading ? (<>
                                    <Placeholder size={'sm'} xs={3} /><br />
                                    <Placeholder size={'sm'} xs={3} /><br />
                                    <Placeholder size={'sm'} xs={3} /><br />
                                    <Placeholder size={'sm'} xs={3} /><br />
                                    <Placeholder size={'sm'} xs={3} />
                                </>) : (
                                <>
                                    <li><b>Type : </b>{property?.type}</li>
                                    <li><b>Surface : </b>{property?.surface} m²</li>
                                    <li><b>Année de construction : </b>{property?.annee_construction}</li>
                                    <li><b>Chambres : </b>{property.b}</li>
                                    {property?.bathrooms.length > 0 && <li><b>Salles de bain : </b>{property?.bathrooms.length}</li>}
                                    {property?.garages.length > 0 && <li><b>Parking : </b>{property?.garages.length}</li>}
                                    {property?.bedrooms.length > 0 && <li><b>Chambres : </b>{property?.bedrooms.length}</li>}
                                </>
                                )}
                            </ul>
                        </div> */}

                        {/* Property details et Caractéristiques */}
                        <div className='mb-4 pb-md-3'>

                            <h3 className='h4'>{t("Détails du bien")}</h3>
                            <DetailProperty property={property} />
                        </div>
                        {/* Property details list */}
                        {property?.mandat == 'vente' && (
                            <div className='mb-4 pb-md-3'>
                                <h3 className='h4'>{t("Détail du prix")}</h3>
                                {/* An accordion, not a list: a <ul> here is invalid HTML */}
                                <PriceProperty property={property} />
                            </div>)}


                        {/* Post meta */}
                        <div className='mb-lg-5 mb-md-4 pb-lg-2 py-4 border-top'>
                            <ul className='d-flex mb-4 list-unstyled fs-sm'>
                                {/*<li className='me-3 pe-3 border-end'>Publié le : <b>9 Décembre 2023</b></li>*/}
                                {/*<li className='me-3 pe-3 border-end'>Référence du bien : <b>681013232</b></li>*/}
                                {/*<li className='me-3 pe-3'>Vues : <b>48</b></li>*/}
                                {loading ? <Placeholder xs='9' size={'lg'} /> : (
                                    <>
                                        <li className='me-3 pe-3 border-end'>{t("Publié le :")} <b>{moment(property?.created_at, 'YYYY-MM-DD HH:mm:ss').format('D MMMM YYYY')}</b></li>
                                        <li className='me-3 pe-3 border-end'>{t("Référence du bien :")} <b>FKB-{property?.id_property}</b></li>
                                        {/*<li className='me-3 pe-3'>Vues : <b>48</b></li>*/}
                                    </>
                                )}
                            </ul>
                        </div>

                    </Col>


                    {/* Sidebar */}
                    <Col as='aside' md={5} lg={4} className='fixed ms-lg-auto pb-1'>

                        {/* Seller's card */}
                        <Card className='sticky-top shadow-sm mb-4' style={{ top: '90px' }}>
                            <Card.Body>
                                <ul className="list-unstyled border-bottom mb-4 pb-4">
                                    <li>
                                        <a href={`tel:${property?.agent?.indicatif_phone_number + property?.agent?.phone_number}`} className="nav-link fw-normal p-0">
                                            <i className="fi-phone mt-n1 me-2 align-middle opacity-60"></i>
                                            {property?.agent?.indicatif_phone_number} {property?.agent?.phone_number}
                                        </a>
                                    </li>
                                    <li>
                                        <a href="mailto:contact@facilykey.com" className="nav-link fw-normal p-0">
                                            <i className="fi-mail mt-n1 me-2 align-middle opacity-60"></i>
                                            contact@facilykey.com
                                        </a>
                                    </li>
                                </ul>
                                {/* Contact form */}
                                <Form
                                    noValidate
                                    validated={contactValidated}
                                    onSubmit={handleContactSubmit}
                                >
                                    <Form.Group className='mb-3'>
                                        <Form.Control placeholder={t('Votre nom*')} name='nom' required />
                                        <Form.Control.Feedback type='invalid'>
                                            {t("Veuillez saisir votre nom")}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className='mb-3'>
                                        <Form.Control placeholder={t('Votre prénom*')} name='prenom' required />
                                        <Form.Control.Feedback type='invalid'>
                                            {t("Veuillez saisir votre prénom")}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className='mb-3'>
                                        <Form.Control type='email' name='email' placeholder={t('Adresse email*')} required />
                                        <Form.Control.Feedback type='invalid'>
                                            {t("Veuillez fournir une adresse email valide")}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className='mb-3'>
                                        <PhoneInput
                                            defaultCountry="ma"
                                            preferredCountries={['ma']}
                                            placeholder="+212 6 20 48 62 77"
                                            value={phoneNumber}
                                            onChange={(value) => setPhoneNumber(value)}
                                            onBlur={() => setTouched(true)}
                                            inputStyle={{
                                                width: '100%',
                                                height: 'calc(1.5em + 0.75rem + 8px)',
                                                padding: '0.575rem 1.125rem',
                                                fontSize: '1rem',
                                                lineHeight: 1.5,
                                                color: '#404956',
                                                borderEndEndRadius: '0.5rem',
                                                borderStartEndRadius: '0.5rem',
                                                borderColor: touched && !isValid ? '#dc3545' : '#cfd4dc',
                                            }}
                                            countrySelectorStyleProps={{
                                                buttonClassName: 'px-4',
                                                buttonStyle: {
                                                    height: 'calc(1.5em + 0.75rem + 8px)',
                                                    padding: '0.575rem 1.125rem',
                                                    fontSize: '1rem',
                                                    lineHeight: 1.5,
                                                    color: '#404956',
                                                    borderStartStartRadius: '0.5rem',
                                                    borderEndStartRadius: '0.5rem',
                                                    borderColor: touched && !isValid ? '#dc3545' : '#cfd4dc',
                                                },
                                            }}
                                        />
                                        {touched && !isValid && (
                                            <div className="invalid-feedback d-block">
                                                {t("Veuillez fournir un numéro de téléphone valide")}
                                            </div>
                                        )}
                                    </Form.Group>

                                    <Form.Group className='mb-3'>
                                        <Form.Control as='textarea' name="message" rows={3} placeholder={t('Message')} style={{ resize: 'none' }} />
                                    </Form.Group>
                                    <Button type='submit' size='lg' className='w-100'>{t("Envoyer la demande")}</Button>
                                </Form>

                            </Card.Body>
                        </Card>

                        {/*<LightGallery*/}
                        {/*    selector='#map'*/}
                        {/*    licenseKey='D4194FDD-48924833-A54AECA3-D6F8E646'*/}
                        {/*    zoomFromOrigin={false}*/}
                        {/*    elementClassNames='position-relative d-flex flex-column pt-2 mb-2'*/}
                        {/*>*/}
                        {/*    <ImageLoader*/}
                        {/*        src='/images/single/map.jpg'*/}
                        {/*        width={832}*/}
                        {/*        height={400}*/}
                        {/*        alt='Map'*/}
                        {/*        className='rounded-3'*/}
                        {/*    />*/}
                        {/*    <div className='d-flex w-100 h-100 align-items-center justify-content-center position-absolute top-0 start-0'>*/}
                        {/*        <Button*/}
                        {/*            id='map'*/}
                        {/*            href='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.6145424811048!2d-73.93999278406218!3d40.74850644331743!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2592979d4827f%3A0x3a5d8b3cf779f3b6!2s28%20Jackson%20Ave%2C%20Long%20Island%20City%2C%20NY%2011101%2C%20USA!5e0!3m2!1sen!2sua!4v1618074552281!5m2!1sen!2sua'*/}
                        {/*            variant='primary stretched-link'*/}
                        {/*            data-iframe={true}*/}
                        {/*        >*/}
                        {/*            <i className='fi-route me-2'></i>*/}
                        {/*            Découvrir la localisation*/}
                        {/*        </Button>*/}
                        {/*    </div>*/}
                        {/*</LightGallery>*/}
                        {/*<p className='mb-0 fs-sm text-center'>{property?.ville}, {property?.code_postale}</p>*/}
                    </Col>
                </Row>
            </Container>


        </RealEstatePageLayout>
    )
}
// Fields the page and its components display. The API also returns internal
// data (fees, commissions, mandate, contacts) that must not reach the browser.
const PUBLIC_FIELDS = [
    'id_property', 'title', 'type', 'mandat', 'price', 'prix_vente', 'prix_loyer', 'is_new',
    'description_fiche_commerciale', 'thumbnail', 'images', 'created_at', 'updated_at',
    'ville', 'quartier', 'code_postal', 'code_postale',
    'surface', 'surface_habitable', 'surface_terrain', 'annee_construction', 'nombre_pieces',
    'bedrooms', 'bathrooms', 'garages', 'nbr_parking',
    'nb_chambre', 'nb_chambre_sdb', 'nb_salle_de_bain', 'nb_salle_eau', 'nb_salon', 'nb_sejour',
    'prestations', 'sous_prestations', 'agent',
    'registration_fees', 'land_conservation_rights', 'certificate_of_ownership_and_fixed_rights',
    'notary_fees', 'VAT_notary_fees', 'frais_dossiers_divers', 'service_charges_to_be_paid_by_the_buyer',
];

export async function getServerSideProps({ params, res, locale }) {
    const id_property = listingIdFromSlug(params.id);
    if (!id_property) {
        return {
            notFound: true,
        };
    }
    try {
        const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/ads/properties/detail/${id_property}`);

        if (!response.ok) {
            return {
                notFound: true,
            };
        }

        const property = await response.json();

        if (property.error || !property.data) {
            return {
                notFound: true,
            };
        }

        // Old links ("Villa de 255 m² à ...-FKB873") move permanently to the clean slug
        const canonicalPath = listingPath(property.data.title, id_property);
        if (`/catalog/${params.id}` !== canonicalPath) {
            return {
                redirect: { destination: localizedPath(canonicalPath, locale), permanent: true },
            };
        }

        // Same listing for every visitor: let the CDN serve it for a minute
        res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=300');

        const publicData = Object.fromEntries(
            PUBLIC_FIELDS.filter((key) => key in property.data).map((key) => [key, property.data[key]])
        );

        return {
            props: publicData,
        };
    } catch (error) {
        console.error('Error fetching property:', error);
        return {
            notFound: true,
        };
    }
}


export default SinglePropertyPage
